<template>
  <div class="comment-container">
    <div class="comment-wrapper">
      <div class="comment-title-view">
        <div class="comment-title">我的评价</div>
      </div>
      <div class="break-line"/>
      <div class="whatever">
        <div
          v-for="(item, index) in commentDatas"
          :key="index"
          class="comment-view">
          <div class="title-stars-time">
            <div class="title-stars">
              <span class="title">
                <img class="icon" src="../../../static/img/user/icon_wdpj_dp.png">
                {{ item.busi_name }}：{{item.menu_name}}
              </span>
              <Stars :stars="Math.ceil(item.score / 2)" :starWidth="16" class="star"/>
            </div>
            <span class="time">{{ item.create_time }}</span>
          </div>
          <span class="comment">{{ item.comment }}</span>
          <div class="comment-bl"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Stars from '@/components/common/stars'

export default {
  name: 'Comment',
  components: {
    Stars
  },
  mounted () {
    this.$nextTick(() => {
      let params = {
        page_now: this.now_page,
        user_id: this.$store.state.user_info.id
      }
      // 请求数据
      this.APIS.REQUEST_COMMENTS(params)
      .then((res) => {
        if (res.data.status === 0) {
          this.commentDatas = res.data.discuss_data
        }
      })
      .catch((err) => {
        this.$store.commit('show_alert', '登陆超时，请重新登录')
        // 跳转到登陆界面
        this.$router.push('/p/login')
      })
    })
  },
  data () {
    return {
      commentDatas: [],
      now_page: 1
    }
  }
}
</script>

<style lang="less" scoped>
.comment-container {
  width: 100%;
  display: flex;
  justify-content: center;
  .comment-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .comment-title-view {
      width: 900px;
      .comment-title {
        font-size: 20px;
        color: #333333;
        margin-top: 30px;
      }
    }
    .break-line {
      width: 900px;
      margin-top: 20px;
      border-bottom: 1px solid #e0e0e0;
    }
    .whatever {
      width: calc(~"100% - 16px");
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: auto;
      .comment-view {
        width: 900px;
        margin-top: 20px;
        .title-stars-time {
          width: 100%;
          height: 40px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .title-stars {
            display: inherit;
            .title {
              height: 100%;
              padding: 8px 16px;
              margin-right: 12px;
              background-color: #fafafa;
              border-radius: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 16px;
              color: #333333;
              .icon {
                width: 16px;
                height: 16px;
                margin-right: 5px;
              }
            }
            .star {
              margin-left: 20px;
            }
          }
          .time {
            font-size: 16px;
            color: #999999;
          }
        }
        .comment {
          width: 100%;
          display: inline-block;
          margin-top: 15px;
          margin-left: 10px;
          font-size: 16px;
          color: #333333;
        }
        .comment-bl {
          margin-top: 20px;
          margin-left: 10px;
          border-bottom: 1px solid #e0e0e0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/comment.vue